module.exports = __webpack_public_path__ + "static/media/image-3.2796a664.png";